import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check, Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { currentLang, changeLanguage, getCurrentLanguage, languages } = useLanguage();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang.code);
    setIsOpen(false);
  };

  const current = getCurrentLanguage();

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 border border-purple-500 text-white transition-all duration-200 shadow-md"
        aria-label="Change language"
        data-testid="language-switcher"
      >
        <span className="text-lg">{current.flag}</span>
        <span className="hidden sm:inline text-sm font-semibold text-white">
          {current.name}
        </span>
        <ChevronDown className={`w-4 h-4 text-white transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown Menu - z-index 50 to not cover platform elements */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-[#2D0C4B] border border-purple-500/30 rounded-xl shadow-2xl overflow-hidden z-50">
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-purple-500/20 transition-colors ${
                  currentLang === lang.code ? 'bg-purple-500/30' : ''
                }`}
              >
                <span className="text-xl">{lang.flag}</span>
                <span className="flex-1 text-white text-sm font-medium">
                  {lang.name}
                </span>
                {currentLang === lang.code && (
                  <Check className="w-4 h-4 text-green-400" />
                )}
              </button>
            ))}
          </div>
          
          <div className="px-4 py-2 border-t border-purple-500/20 bg-black/20">
            <p className="text-white/60 text-xs flex items-center gap-1">
              <Languages className="w-3 h-3" />
              Multi-language
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
